import { ASSIGN_CONTENT_FEED_ACTIONS } from "reducers/actions/AssignContentFeed";
import createReducer from "reducers/createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const normalizeToArray = (items) => {
	return Array.isArray(items) ? items : [items];
};

const buildGrowlMessage = successMessage => (response, success) => {
	if (success) {
		return {
			id: new Date().getTime(),
			type: "success",
			messageHeader: successMessage,
			message: successMessage,
		};
	}
	return {
		id: new Date().getTime(),
		type: "error",
		messageHeader: "Error",
		message: response?.data?.description || response?.data?.error || "Unexpected error",
	};
};

const buildAssignMessage = buildGrowlMessage("Bulk Sheet assigned successfully");
const buildAssignBlankMessage = buildGrowlMessage("Bulk Sheet created and assigned successfully");
const buildAssignExistingMessage = buildGrowlMessage("Bulk Sheet assigned successfully");

export const assignContentFeed = (sourceUrl, sourceType, creativeIds, email, creativeLibraryId, feedName = null) => {
	const requestData = {
		sourceUrl,
		sourceType,
		creativeIds: normalizeToArray(creativeIds),
		email,
		creativeLibraryId,
		...(feedName && { feedName }),
	};

	return (dispatch) => {
		return dispatch({
			type: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_CONTENT_FEED_AJAX,
			AJAX: {
				url: `ui/content-feed/assign`,
				method: 'post',
				data: requestData,
				success: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_CONTENT_FEED_SUCCESS,
				error: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_CONTENT_FEED_ERROR,
			},
			meta: {
				buildMessage: buildAssignMessage,
			},
		});
	};
};

export const fetchLibraryContentFeeds = (libraryId) => {
	return (dispatch) => {
		return dispatch({
			type: ASSIGN_CONTENT_FEED_ACTIONS.FETCH_LIBRARY_CONTENT_FEEDS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/content-feed/list/${libraryId}`,
				method: 'get',
				params: { rpp: 1000, page: 1 },
				success: ASSIGN_CONTENT_FEED_ACTIONS.FETCH_LIBRARY_CONTENT_FEEDS_SUCCESS,
				error: ASSIGN_CONTENT_FEED_ACTIONS.FETCH_LIBRARY_CONTENT_FEEDS_ERROR,
			},
		});
	};
};

export const assignBlankContentFeed = (feedName, email, sourceType, creativeIds, creativeLibraryId) => {
	return (dispatch) => {
		return dispatch({
			type: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_BLANK_CONTENT_FEED_AJAX,
			AJAX: {
				url: `ui/content-feed/assign-blank`,
				method: 'post',
				data: { feedName, email, sourceType, creativeIds: normalizeToArray(creativeIds), creativeLibraryId },
				success: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_BLANK_CONTENT_FEED_SUCCESS,
				error: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_BLANK_CONTENT_FEED_ERROR,
			},
			meta: {
				buildMessage: buildAssignBlankMessage,
			},
		});
	};
};

export const assignExistingContentFeed = (creativeIds, contentFeedId, creativeLibraryId) => {
	return (dispatch) => {
		return dispatch({
			type: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_EXISTING_CONTENT_FEED_AJAX,
			AJAX: {
				url: `ui/content-feed/assign-existing`,
				method: 'post',
				data: { creativeIds: normalizeToArray(creativeIds), contentFeedId, creativeLibraryId },
				success: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_EXISTING_CONTENT_FEED_SUCCESS,
				error: ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_EXISTING_CONTENT_FEED_ERROR,
			},
			meta: {
				buildMessage: buildAssignExistingMessage,
			},
		});
	};
};

const initialState = {
	isLoaded: false,
	isSaving: false,
	hasErrorLoading: false,
	data: {},
};

const isLinkingSpreadsheet = (state, action) => {
	return {
		...state,
		isLoaded: false,
		isSaving: false,
		hasErrorLoading: false,
		data: { ...action.payload.data },
	};
};

const success = (state, action) => {
	return {
		...state,
		isLoaded: true,
		isSaving: false,
		hasErrorLoading: false,
		data: { ...action.payload.data },
	};
};

const error = (state) => {
	return {
		...state,
		isLoaded: true,
		isSaving: false,
		hasErrorLoading: true,
		data: {},
	};
};

const handlers = {
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_CONTENT_FEED_AJAX]: isLinkingSpreadsheet,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_CONTENT_FEED_SUCCESS]: success,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_CONTENT_FEED_ERROR]: error,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_BLANK_CONTENT_FEED_AJAX]: isLinkingSpreadsheet,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_BLANK_CONTENT_FEED_SUCCESS]: success,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_BLANK_CONTENT_FEED_ERROR]: error,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_EXISTING_CONTENT_FEED_AJAX]: isLinkingSpreadsheet,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_EXISTING_CONTENT_FEED_SUCCESS]: success,
	[ASSIGN_CONTENT_FEED_ACTIONS.ASSIGN_EXISTING_CONTENT_FEED_ERROR]: error,
};

export default createReducer(initialState, handlers);
